import { jsx as e } from "react/jsx-runtime";
// lib/List/components/ListItem.tsx
var t = ({ children: t }) => /* @__PURE__ */ e("div", {
	className: "list-item pl-4",
	children: t
});
export { t as ListItem };
